"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDimensionsFromDataSourceFields = void 0;
const attributes_js_1 = require("../attributes.js");
const dimensions_js_1 = require("./dimensions.js");
const utils_js_1 = require("../../utils.js");
/**
 * Function to convert data source fields to dimensions.
 * @param fields - The data source fields to convert.
 * @param dataSource - The data source title.
 * @returns - The dimensions created from the data source fields.
 * @internal
 */
function getDimensionsFromDataSourceFields(fields, dataSource) {
    const attributeEntries = fields.map((field) => createAttributeEntry(field, dataSource));
    const groupedConfigs = groupAttributesByDimension(attributeEntries);
    return Object.values(groupedConfigs).map((config) => (0, dimensions_js_1.createDimension)(config));
}
exports.getDimensionsFromDataSourceFields = getDimensionsFromDataSourceFields;
/**
 * Given a DataSourceField and the data source title, creates an attribute entry
 * that includes the dimension name, attribute name, and the attribute itself.
 */
const createAttributeEntry = (field, dataSource) => {
    const dimensionId = field.table;
    const dimensionName = field.tableTitle || dimensionId;
    const attributeId = field.id;
    const attributeName = field.title || attributeId;
    const dataSourceConfig = (0, utils_js_1.isDataSourceInfo)(dataSource)
        ? dataSource
        : { title: dataSource, live: false };
    const attribute = field.dimtype === 'datetime'
        ? (0, dimensions_js_1.createDateDimension)({
            name: attributeName,
            expression: attributeId,
            dataSource: dataSourceConfig,
        })
        : (0, attributes_js_1.createAttribute)({
            name: attributeName,
            type: field.dimtype === 'text' ? 'text-attribute' : 'numeric-attribute',
            expression: attributeId,
            dataSource: dataSourceConfig,
        });
    return {
        dimension: {
            id: dimensionId,
            name: dimensionName,
        },
        attribute,
    };
};
/**
 * Groups an array of attribute entries by their dimension name.
 * Returns an object whose keys are dimension names and values are configuration objects
 * that can be passed to createDimension.
 */
const groupAttributesByDimension = (entries) => entries.reduce((acc, { dimension, attribute }) => {
    const dimensionConfig = acc[dimension.name] || {
        name: dimension.name,
        expression: dimension.id,
    };
    return Object.assign(Object.assign({}, acc), { [dimension.name]: Object.assign(Object.assign({}, dimensionConfig), { [attribute.name]: attribute }) });
}, {});
